import { atom } from 'jotai';
import { noop } from 'lodash';
import * as Types from '../utils/types';

export const isLoading = atom(false);
export const isDimensionLoading = atom(false);
export const isDimensionError = atom(false);
export const DimensionAdded = atom(0);
export const dimensionsData = atom<Types.DimensionPayload>({
  configId: 0,
  configurationVersion: 0,
  dimensions: [],
});
export const dimensionMetaLoading = atom(false);
export const dimensionsMetaError = atom(false);
export const dimensionMeta = atom<Types.DimensionMeta[]>([]);

export interface ManagementProps {
  dimensionVisible?: boolean;
  isDimensionLoading: boolean;
  isDimensionError: boolean;
  dimensionsData: Types.DimensionPayload;
  isDimensionMetaLoading: boolean;
  isDimensionMetaError: boolean;
  dimensionMeta: Types.DimensionMeta[];
  onClose?: () => void;
  onEdit?: (payload: Types.DimensionPayload) => any;
}

export const callbacks = atom({
  onClose: noop as ManagementProps['onClose'],
  onEdit: noop as ManagementProps['onEdit'],
});
